import { useEffect, useRef, useState } from "react";
import { Platform } from "react-native";
import { useRouter, useRootNavigationState } from "expo-router";
import { useAuthStore } from "@src/features/auth";
import { View } from "@src/components/View";
import { Text } from "@src/components/Text";
import { Loading } from "@src/components/Loading";
import { unregisterPushToken } from "@src/features/notifications";

export default function LogoutScreen() {
  const router = useRouter();
  const rootNavigationState = useRootNavigationState();
  const isLoggingOut = useRef(false);
  const [loggedOut, setLoggedOut] = useState(false);

  useEffect(() => {
    if (isLoggingOut.current) return;

    async function performLogout() {
      isLoggingOut.current = true;

      // Native-only: web has no FCM device token registration in this app.
      if (Platform.OS !== "web") {
        try {
          await unregisterPushToken();
        } catch (error: unknown) {
          console.error("[Logout] Push token cleanup failed (continuing logout):", error);
        }
      }

      try {
        await useAuthStore.getState().clearAuth();
      } catch (error: unknown) {
        console.error("[Logout] clearAuth failed:", error);
      } finally {
        setLoggedOut(true);
      }
    }

    void performLogout();
  }, []);

  // Single navigation effect keyed on both logout completion and nav
  // readiness, so it fires whichever settles last.
  useEffect(() => {
    if (!loggedOut) return;
    if (!rootNavigationState?.key) return;
    router.replace("/");
  }, [loggedOut, router, rootNavigationState?.key]);

  return (
    <View flex={1} bg="background" justifyContent="center" alignItems="center" gap="lg">
      <Loading />
      <Text textStyle="md/regular" color="textMuted">
        Logging out...
      </Text>
    </View>
  );
}
